import LatestStudents from './LatestStudents';
import LatestSchools from './LatestSchools';
import Transactions from './Transactions';
import { UserHeader } from '../../components/user-header';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../slices/auth';
import { SponsorRow } from '../../components/sponsor-row/sponsor-row';
import { SocketActions, SponsorPlacements } from '../../utils/constants';
import { Outlet, useLocation } from 'react-router';
import RecentlyDeletedUsers from './RecentlyDeletedUsers';
import MatchChatDisputes from './DashboardMatchChatDisputes';
import DashboardAnnouncement from '../../components/dashboard-announcement';
import OgmaDashboardInbox from '../ogma-dashboard/route/omga-inbox/ogma-dashboard-inbox';
import { useEffect } from 'react';
import {
  useGetAllAnnouncementsQuery,
  useGetAllChatroomsQuery,
  useGetAllFlaggedMatchChatsQuery,
  useGetAllMatchChatsQuery,
} from '../../slices/inboxApiSlice';

const Dashboard = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const location = useLocation();
  const isMessageView =
    location.pathname.includes('/dashboard/admin/message/') ||
    location.pathname.includes('/dashboard/admin/new');
  useGetAllChatroomsQuery({});
  useGetAllFlaggedMatchChatsQuery({});
  useGetAllMatchChatsQuery({});
  useGetAllAnnouncementsQuery({});
  useEffect(() => {
    dispatch({
      type: SocketActions.ConnectInbox,
      payload: { id: user.id },
    });
  }, []);
  return (
    <>
      <div className='flex flex-col p-10 gap-10 '>
        <SponsorRow name={SponsorPlacements.Dashboard} />
        <DashboardAnnouncement />
        <UserHeader
          name={user.firstName}
          lastName={user.lastName}
          image={user.image}
          id={user.id}
          username={user.username}
        />
        <div className='border border-gray-200 px-4 pb-4 mb-4 rounded-lg'>
          <h1 className='text-2xl font-bold border-b border-gray-200 p-4 mb-4'>Inbox</h1>
          {isMessageView ? <Outlet /> : <OgmaDashboardInbox />}
        </div>
        <MatchChatDisputes />
        <Transactions />
        <RecentlyDeletedUsers />
        <LatestStudents />
        <LatestSchools />
      </div>
      {!isMessageView && <Outlet />}
    </>
  );
};

export default Dashboard;
